export type FaqItem = { question: string; answer: string };

export const HOME_FAQ: FaqItem[] = [
  {
    question: 'What is Edvello?',
    answer:
      'Edvello is tuition and coaching institute management software with a built-in learning platform. It brings courses, live online classes, batches, timetables, attendance, assessments and a branded institution website into one shared workspace.'
  },
  {
    question: 'Who is Edvello for?',
    answer:
      'Edvello is built for tuition teachers, coaching institutes and schools in India. Administrators manage the institution, teachers organise their courses and batches, and students and guardians follow their learning in the same platform.'
  },
  {
    question: 'Is Edvello a learning management system (LMS)?',
    answer:
      'Yes. Edvello includes a learning management system for structured courses with video lessons, PDFs, exercises, grading and progress tracking, together with the batch, timetable and attendance tools a coaching institute needs every day.'
  },
  {
    question: 'Can we teach live and share recorded lessons?',
    answer:
      'Yes. Schedule live sessions with classroom joining links and calendar invitations. You can also organise recorded video lessons, PDFs and exercises into courses that students access at their own pace.'
  },
  {
    question: 'How do we organise our students and teachers?',
    answer:
      'Create batches, assign teachers and enrol students. Each batch brings its timetable, manual attendance, materials and notices together. Guardian relationships stay connected to student records.'
  },
  {
    question: 'Can we review work and track progress?',
    answer:
      'Teachers can set exercises, review submissions, record marks and give individual feedback. Students retain their course progress, and course completion can connect to certificates.'
  },
  {
    question: 'Can our institution use its own branding?',
    answer:
      'Yes. Add your institution logo and colours, configure your website layout and present your course catalogue under your institution’s identity.'
  },
  {
    question: 'How do we get started?',
    answer:
      'Send us a message through the contact form. Tell us about your institution, your courses and roughly how many students you teach, and the Edvello team will help you set up your workspace.'
  }
];

export const PRODUCT_FAQ: FaqItem[] = [
  {
    question: 'What is an LMS for a coaching institute?',
    answer:
      'A learning management system stores course materials and student work. Edvello connects those courses with teaching batches, so teachers can share lessons with enrolled students and review their submissions.'
  },
  {
    question: 'How is a batch different from a course?',
    answer:
      'A course contains reusable teaching materials, such as lessons and exercises. A batch is a group of enrolled students with assigned teachers and a timetable. Edvello keeps the course content separate from the group that studies it.'
  },
  {
    question: 'Can teachers record attendance for a tuition batch?',
    answer:
      'Teachers can record manual attendance for a batch. Batch records also connect enrolled students with their teachers and timetable. Automatic attendance from the built-in live classroom is planned.'
  },
  {
    question: 'Does Edvello include student fee collection?',
    answer:
      'Student fee collection is planned. Your institution’s Edvello subscription is separate from the tuition fees students pay your institution. Contact the Edvello team to discuss the capabilities available for your institution.'
  }
];

export const PRICING_FAQ: FaqItem[] = [
  {
    question: 'How are subscriptions arranged?',
    answer:
      'Subscription terms are agreed with each institution. We discuss your learner numbers, courses and requirements before preparing a proposal.'
  },
  {
    question: 'Is there a setup fee?',
    answer:
      'Setup is discussed as part of your proposal. Tell us how many teachers, batches and students you work with and we will explain what onboarding involves.'
  },
  {
    question: 'Are student fee payments included?',
    answer:
      'No. Your Edvello subscription is separate from the tuition fees your students pay you. Student fee collection is a planned capability and will stay separate from your subscription.'
  },
  {
    question: 'Can students learn on a phone?',
    answer:
      'Yes. The learning experience works in a web browser, including on phones. Students can open their courses and materials without installing a separate app.'
  },
  {
    question: 'How do students get access?',
    answer:
      'Your institution manages enrollment. Students join through an invitation from your institution and see the courses and batches they are enrolled in.'
  },
  {
    question: 'How do existing users sign in?',
    answer:
      'Use Sign in at the top of the page to open the Edvello application. Students should use the link provided by their institution.'
  }
];
